import React, { Component } from "react";
import { Form, Input, Button, Checkbox, message } from "antd";
import { Link, withRouter } from "react-router-dom";
import "../../scss/auth.scss";
import {
  CheckForgetPasswordCode,
  verifyEmail,
  verifyPhone,
} from "../../network/auth.network";
import { connect } from "react-redux";
import { setCurrentUser } from "../../redux/user/user.action";
import localization from "../../Localization/Localization.json";
import logo from "../../assets/verify.png";
import authBG from "../../assets/auth.png";
import { FaChevronRight } from "react-icons/fa";
import OtpInput from "react-otp-input";

// import TiSocialFacebookCircular from 'react-icons/lib/ti/social-facebook-circular';

class PhoneVerify extends Component {
  constructor() {
    super();
    this.state = {
      btnLoading: false,
      isLoginValid: false,
      otp: "",
      timer: 120,
    };
    this.timerInt = "";
  }
  componentDidMount() {
    this.state.timer === 120 &&
      setTimeout(() => this.setState({ timer: this.state.timer - 1 }), 1000);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.timer !== this.state.timer) {
      this.timerInt =
        this.state.timer > 0
          ? setTimeout(
              () => this.setState({ timer: this.state.timer - 1 }),
              1000
            )
          : this.props.history.replace("/signin");
    }
  }
  // componentWillUnmount(){
  //   clearInterval(this.timerInt);
  // }
  handleChange = (otp) => this.setState({ otp });

  routeToDashboard = () => {
    let userOtp = this.state.otp;
    let body = {
      // Email: this.props.location?.state?.email,
      PhoneKey: this.props.location?.state?.PhoneKey,
      PhoneNumber: this.props.location?.state?.PhoneNumber,
      Code: userOtp,
    };
    if (this.props?.location?.state?.status === 0) {
      CheckForgetPasswordCode(
        body,
        (res) => {
          this.props.history.replace({
            pathname: `/reset-password`,
            state: { code: userOtp, email: this.props.location?.state?.email },
          });
        },
        () => {
          message.error("ادخل الرمز بطريقة صحيحة");
        }
      );
    } else {
      verifyPhone(
        body,
        (res) => {
          this.props.history.replace({ pathname: `/signin` });
        },
        () => {
          message.error("ادخل الرمز بطريقة صحيحة");
        }
      );
    }
  };

  render() {
    const { btnLoading, isLoginValid } = this.state;
    const { currentLang } = this.props;
    return (
      <div className="auth-wrapper page-wrapper-no-header">
        <img src={authBG} className="auth-bg" alt="" />
        <div className="auth-form-content">
          <Link to="/home" className="logo-holder">
            <img src={logo} alt="logo" />
          </Link>
          <p className="form-hint-h">
            من فضلك قم بادخال رمز التحقق المرسل للهاتف ادناه
          </p>
          <span className="form-mail-s">
            {this.props.location?.state?.PhoneKey +
              this.props.location?.state?.PhoneNumber}
          </span>
          <div className="otp-form-holder">
            <OtpInput
              value={this.state.otp}
              isInputNum
              hasErrored={true}
              shouldAutoFocus
              onChange={this.handleChange}
              numInputs={4}
              separator={<span></span>}
              className="input-otp"
            />
            <p className="resend-verify" style={{ marginBottom: "15px" }}>
              اعاده ارسال الرمز بعد {+this.state.timer} ثانية
            </p>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              block
              loading={btnLoading}
              onClick={this.routeToDashboard}
            >
              تحقق
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang: state.user.currentLang,
});

const LoginWithRouter = withRouter(PhoneVerify);
export default connect(mapStateToProps)(LoginWithRouter);
